import React from "react";
import "./Terms&Conditions.css";

const TermsAndConditions = () => {
  return (
    <div className="terms-container">
      <h1>Terms & Conditions</h1>

      <section>
        <h2>1. Exclusive Terms and Conditions</h2>
        <p>
          These General Terms and Conditions, in combination with any quotation and any order
          acknowledgment which may have been supplied by CUTTECH SOLUTIONS (collectively
          the Agreement), are intended by the parties as the final expression of their agreement and
          are the complete and exclusive statement of the terms and conditions of that Agreement for
          all transactions between the parties...
        </p>
      </section>

      <section>
        <h2>2. Payment</h2>
        <p>
          Unless otherwise stated, all invoices are due and payable as follows: Net 30. Invoices for
          products or services delivered under this Agreement are payable only in Indian Rupees (INR)...
        </p>
      </section>

      <section>
        <h2>3. Prices and Delivery; Confidentiality</h2>
        <p>
          Unless otherwise stated, prices are subject to change without notice, including as a result of
          currency fluctuation or raw material costs. Delivery of the Products shall be F.C.A...
        </p>
      </section>

      <section>
        <h2>4. Export Restrictions & Legal Compliance</h2>
        <p>
          Buyer shall comply with applicable Indian and international export laws. Buyer agrees not to
          engage in any transaction that violates the Foreign Corrupt Practices Act or any similar
          regulation...
        </p>
      </section>

      <section>
        <h2>5. Taxes and Charges</h2>
        <p>
          All applicable duties, levies, and taxes imposed in connection with the purchase or sale of
          Products and Services are to be borne by the Buyer...
        </p>
      </section>

      <section>
        <h2>6. Delays and Force Majeure</h2>
        <p>
          Any delay caused by force majeure—including natural disasters, political unrest, labor
          shortages, or any other event beyond control of CUTTECH SOLUTIONS—shall extend...
        </p>
      </section>

      <section>
        <h2>7. Warranties</h2>
        <p>
          CUTTECH SOLUTIONS warrants its Products to be free from defects in material and
          workmanship for a period of 30 days after delivery...
        </p>
      </section>

      <section>
        <h2>8. Returns & Cancellations</h2>
        <p>
          Products returned without proper written authorization (RMA #) will not be accepted.
          Returns must be made within 30 days, and custom products are non-cancellable...
        </p>
      </section>

      <section>
        <h2>9. Limitation of Liability</h2>
        <p>
          In no event shall CUTTECH SOLUTIONS be liable for indirect, special, incidental, or
          consequential damages...
        </p>
      </section>

      <section>
        <h2>10. Intellectual Property</h2>
        <p>
          All intellectual property, including designs, formulas, and trademarks, remain the exclusive
          property of SIMPLE MECHANICAL SOLUTIONS and/or SAGAR’S GROUP OF INDUSTRIES...
        </p>
      </section>

      <section>
        <h2>11. Indemnification</h2>
        <p>
          Buyer agrees to indemnify and hold harmless CUTTECH SOLUTIONS, its affiliates, and
          parent companies against any claims or damages...
        </p>
      </section>

      <section>
        <h2>12. Over or Under Shipment</h2>
        <p>
          Standard allowances for manufacturing variances in non-stock items apply unless otherwise
          agreed in writing...
        </p>
      </section>
    </div>
  );
};

export default TermsAndConditions;